/**
 * lagorii-now.js
 * Floating sticky CTA with manual pincode serviceability check.
 *
 * Geolocation/auto-detect has been removed. On a fresh visit the user
 * is prompted to enter a pincode manually; once entered, it's reused
 * for the rest of the session (sessionStorage).
 */

(function () {
  'use strict';

  /* ─────────────────────────────────────────────
   * 0. PORTAL FIX
   *    .body-content-wrapper has `transition: transform`
   *    set globally in base.css. Any transform property
   *    (even unset) makes an element a new CSS containing
   *    block, which breaks position:fixed on descendants —
   *    they become fixed relative to that wrapper instead
   *    of the viewport, so they appear to scroll away.
   *
   *    Fix: move our fab + modal to be direct children of
   *    <body>, outside .body-content-wrapper, on init.
   *    This runs before anything else so layout never
   *    flashes in the wrong position.
   * ───────────────────────────────────────────── */
  function portalToBody() {
    var fab = document.getElementById('lag-now-fab');
    var modal = document.getElementById('lag-now-modal-overlay');
    [fab, modal].forEach(function (el) {
      if (el && el.parentElement !== document.body) {
        document.body.appendChild(el);
      }
    });
  }

  /* ─────────────────────────────────────────────
   * 1. SERVICEABLE PINCODES LIST
   *    Edit here OR use window.LAGORII_NOW_CONFIG
   *    set via Liquid in the snippet.
   * ───────────────────────────────────────────── */
  var SERVICEABLE_PINCODES = (window.LAGORII_NOW_CONFIG && window.LAGORII_NOW_CONFIG.pincodes)
    ? window.LAGORII_NOW_CONFIG.pincodes
    : [
        '560001','560002','560004','560005','560006','560007','560008','560009','560010',
        '560011','560013','560015','560016','560017','560018','560020','560021','560023',
        '560024','560025','560026','560027','560029','560030','560032','560033','560034',
        '560035','560036','560037','560038','560040','560041','560042','560043','560045',
        '560046','560047','560048','560049','560056','560058','560060','560061','560063',
        '560064','560065','560066','560067','560068','560070','560071','560075','560076',
        '560078','560080','560083','560084','560085','560086','560087','560090','560092',
        '560093','560094','560095','560096','560097','560098','560099','560100','560102'
      ];

  var REDIRECT_URL = (window.LAGORII_NOW_CONFIG && window.LAGORII_NOW_CONFIG.redirectUrl)
    ? window.LAGORII_NOW_CONFIG.redirectUrl
    : '/collections/kids-wear-120-min-delivery-bangalore';

  /**
   * Navigates to a relative (or absolute) URL while preserving the
   * current page's ?preview_theme_id=... parameter, if present.
   * Without this, navigating while previewing an unpublished theme
   * would silently drop you onto the LIVE published theme instead,
   * since a fresh relative URL has no query string of its own.
   */
  function navigateWithinTheme(targetUrl) {
    try {
      var currentParams = new URLSearchParams(window.location.search);
      var previewId = currentParams.get('preview_theme_id');
      if (!previewId) {
        window.location.href = targetUrl;
        return;
      }
      var separator = targetUrl.indexOf('?') === -1 ? '?' : '&';
      window.location.href = targetUrl + separator + 'preview_theme_id=' + encodeURIComponent(previewId);
    } catch (e) {
      window.location.href = targetUrl;
    }
  }

  /* ─────────────────────────────────────────────
   * 2. LOCALSTORAGE KEYS
   * ───────────────────────────────────────────── */
  var LS = {
    PINCODE:       'lag_now_pincode',
    ELIGIBLE:      'lag_now_eligible',
    GEO_DENIED:    'lag_now_geo_denied',
    GEO_TIMESTAMP: 'lag_now_geo_ts',
    GEO_METHOD:    'lag_now_geo_method',  // 'auto' | 'manual'
    // Shared session-wide lock. Set the moment a user MANUALLY enters a
    // pincode in EITHER pincode system (lag_now or LagETA). While present,
    // auto-detect is fully disabled everywhere for the rest of the session.
    // Lives in sessionStorage, so it clears on browser/app close — giving
    // a fresh auto-detect on the next session.
    PIN_LOCKED:    'lag_pin_locked'
  };

  /* ─────────────────────────────────────────────
   * 3. STATE
   * ───────────────────────────────────────────── */
  var state = {
    pincode:  null,
    eligible: null   // true | false | null (unknown)
  };

  /* ─────────────────────────────────────────────
   * 4. UTILITY HELPERS
   * ───────────────────────────────────────────── */
  function lsGet(key) {
    try { return sessionStorage.getItem(key); } catch (e) { return null; }
  }
  function lsSet(key, val) {
    try { sessionStorage.setItem(key, val); } catch (e) {}
  }
  function lsRemove(key) {
    try { sessionStorage.removeItem(key); } catch (e) {}
  }

  function isValidPincode(pin) {
    return /^\d{6}$/.test(String(pin).trim());
  }

  function checkEligibility(pincode) {
    return SERVICEABLE_PINCODES.indexOf(String(pincode).trim()) !== -1;
  }

  /* ─────────────────────────────────────────────
   * 7. PINCODE APPLICATION
   *    Called whenever we have a confirmed pincode
   *    (auto OR manual). Updates state, storage,
   *    cart attributes, and all UI.
   * ───────────────────────────────────────────── */
  function applyPincode(pin, persist) {
    pin = String(pin).trim();
    if (!isValidPincode(pin)) return;

    var eligible = checkEligibility(pin);
    state.pincode  = pin;
    state.eligible = eligible;

    if (persist !== false) {
      lsSet(LS.PINCODE,  pin);
      lsSet(LS.ELIGIBLE, eligible ? '1' : '0');
    }

    // Bridge: mirror this pincode into the LagETA cookie system so the
    // homepage hero ETA + product-page ETA widgets show the same pincode.
    // Guarded: LagETA may not be present on every page (e.g. cart).
    try {
      if (window.LagETA && typeof window.LagETA.byPin === 'function') {
        window.LagETA.byPin(pin);
      }
    } catch (e) {}

    updateFloatingButton();
    updateCartAttributes(pin, eligible);
    // NOTE: closing the modal is now the caller's responsibility. We must
    // NOT close here unconditionally, because an out-of-range manual entry
    // needs to keep the modal open to show the "not available" warning.
  }

  /* ─────────────────────────────────────────────
   * 8. FLOATING BUTTON UI
   * ───────────────────────────────────────────── */
  function updateFloatingButton() {
    var btn = document.getElementById('lag-now-fab');
    if (!btn) return;

    // Button is always visible; only behaviour changes
    if (state.eligible === true) {
      btn.classList.add('lag-now-fab--eligible');
      btn.classList.remove('lag-now-fab--ineligible');
      btn.setAttribute('aria-label', 'Lagorii Now – Delivery in 2 hours. Tap to shop.');
    } else {
      btn.classList.remove('lag-now-fab--eligible');
      btn.classList.add('lag-now-fab--ineligible');
      btn.setAttribute('aria-label', 'Lagorii Now – Check availability in your area.');
    }

    // Pincode pill removed from markup — no longer displayed in the button.
  }

  function onFabClick() {
    // Read the CURRENT pincode from storage at click time. The pincode may
    // have been set via the homepage/product ETA box (a separate system
    // that bridges into sessionStorage but does NOT update our in-memory
    // `state`). Relying on stale `state` here would miss those values and
    // skip the out-of-range message. Storage is the source of truth.
    var currentPin = lsGet(LS.PINCODE);
    var currentEligible = null;
    if (currentPin && isValidPincode(currentPin)) {
      currentEligible = checkEligibility(currentPin);
      // Keep in-memory state coherent too.
      state.pincode = currentPin;
      state.eligible = currentEligible;
    }

    // Out of range: go to the Lagorii Now page FIRST, then show the
    // "Service Not Available" message THERE (via a URL flag the Now page
    // reads on load). We do NOT show the modal on the current page.
    if (currentPin && isValidPincode(currentPin) && currentEligible === false) {
      var sep = REDIRECT_URL.indexOf('?') === -1 ? '?' : '&';
      navigateWithinTheme(REDIRECT_URL + sep + 'lag_oos=1');
      return;
    }

    // In range (or unknown): take the customer straight to the Lagorii
    // Now collection. Same-tab navigation so Back returns them here.
    navigateWithinTheme(REDIRECT_URL);
  }

  /* ─────────────────────────────────────────────
   * 9. MODAL — OUT OF RANGE
   * ───────────────────────────────────────────── */
  function showOutOfRangeModal() {
    var overlay = document.getElementById('lag-now-modal-overlay');
    if (!overlay) return;
    switchModalTab('oor');
    overlay.removeAttribute('hidden');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('lag-now-modal-open');
    // Focus first focusable element
    var firstFocus = overlay.querySelector('button, input, [tabindex]');
    if (firstFocus) setTimeout(function () { firstFocus.focus(); }, 50);
  }

  function showManualEntry(msg) {
    var overlay = document.getElementById('lag-now-modal-overlay');
    if (!overlay) return;
    // Switch to manual entry tab
    switchModalTab('manual');
    if (msg) {
      var hint = overlay.querySelector('.lag-now-modal__hint');
      if (hint) hint.textContent = msg;
    }
    overlay.removeAttribute('hidden');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('lag-now-modal-open');
    var input = overlay.querySelector('#lag-now-pincode-input');
    if (input) setTimeout(function () { input.focus(); }, 50);
  }

  function closeModal() {
    var overlay = document.getElementById('lag-now-modal-overlay');
    if (!overlay) return;
    overlay.setAttribute('hidden', '');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('lag-now-modal-open');
  }

  function switchModalTab(tab) {
    var oor = document.getElementById('lag-now-tab-oor');
    var man = document.getElementById('lag-now-tab-manual');
    if (!oor || !man) return;
    if (tab === 'manual') {
      oor.setAttribute('hidden', '');
      man.removeAttribute('hidden');
    } else {
      man.setAttribute('hidden', '');
      oor.removeAttribute('hidden');
    }
  }

  /* ─────────────────────────────────────────────
   * 10. MANUAL PINCODE SUBMISSION
   * ───────────────────────────────────────────── */
  function handleManualSubmit() {
    var input = document.getElementById('lag-now-pincode-input');
    var errorEl = document.getElementById('lag-now-pincode-error');
    if (!input) return;

    var pin = input.value.trim();
    if (!isValidPincode(pin)) {
      if (errorEl) {
        errorEl.textContent = 'Please enter a valid 6-digit pincode.';
        errorEl.removeAttribute('hidden');
      }
      input.focus();
      return;
    }
    if (errorEl) errorEl.setAttribute('hidden', '');

    lsSet(LS.GEO_METHOD, 'manual');
    lsRemove(LS.GEO_TIMESTAMP); // No TTL for manual entry
    lsSet(LS.PIN_LOCKED, '1');  // Lock: no auto-detect for rest of session
    applyPincode(pin, true);

    // If eligible, redirect after a brief confirmation flash
    if (state.eligible) {
      showEligibleConfirm();
      setTimeout(function () {
        navigateWithinTheme(REDIRECT_URL);
      }, 800);
    } else {
      // Out of range. Behaviour depends on which page we're on:
      //  - On the Lagorii Now collection page: there's nothing to shop
      //    here for an out-of-range customer, so switch to the locked
      //    "Service Not Available" view (no X — only Continue Shopping).
      //  - Anywhere else (e.g. homepage): keep the inline warning so the
      //    user can simply try a different pincode.
      var onNowPage = window.location.pathname.indexOf('kids-wear-120-min-delivery-bangalore') !== -1;
      if (onNowPage) {
        switchModalTab('oor');
      } else {
        showIneligibleConfirm();
      }
    }
  }

  function showEligibleConfirm() {
    var el = document.getElementById('lag-now-confirm-eligible');
    if (el) { el.removeAttribute('hidden'); }
  }

  function showIneligibleConfirm() {
    var el = document.getElementById('lag-now-confirm-ineligible');
    if (el) { el.removeAttribute('hidden'); }
  }

  /* ─────────────────────────────────────────────
   * 11. CART ATTRIBUTES
   *    Writes pincode + delivery mode to Shopify
   *    cart so it's visible in order admin.
   * ───────────────────────────────────────────── */
  function updateCartAttributes(pin, eligible) {
    var attrs = {
      'Delivery Pincode': pin,
      'Lagorii Now Eligible': eligible ? 'Yes' : 'No',
      'Lagorii Now Selected': eligible ? 'Yes' : 'No'
    };
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () { /* silent fail – cart attr is non-critical */ });
  }

  /* ─────────────────────────────────────────────
   * 12. RESTORE FROM LOCALSTORAGE
   * ───────────────────────────────────────────── */
  function restoreFromStorage() {
    var pin = lsGet(LS.PINCODE);
    var elig = lsGet(LS.ELIGIBLE);
    if (pin && isValidPincode(pin) && elig !== null) {
      state.pincode  = pin;
      state.eligible = elig === '1';
      updateFloatingButton();
    }
  }

  /* ─────────────────────────────────────────────
   * 13. EVENT BINDING
   * ───────────────────────────────────────────── */
  function bindEvents() {
    // Floating button
    var fab = document.getElementById('lag-now-fab');
    if (fab) fab.addEventListener('click', onFabClick);

    // Modal overlay click-outside to close
    var overlay = document.getElementById('lag-now-modal-overlay');
    if (overlay) {
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) closeModal();
      });
    }

    // ESC key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });

    // Close buttons
    document.querySelectorAll('[data-lag-now-close]').forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });

    // "Continue Shopping" inside modal → send them to the main site
    // homepage (not just dismiss the modal in place).
    document.querySelectorAll('[data-lag-now-continue]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        navigateWithinTheme('/');
      });
    });

    // "Change Pincode" button (from out-of-range tab)
    var changePinBtn = document.getElementById('lag-now-change-pin-btn');
    if (changePinBtn) {
      changePinBtn.addEventListener('click', function () {
        switchModalTab('manual');
        var input = document.getElementById('lag-now-pincode-input');
        if (input) input.focus();
      });
    }

    // Pincode form submit
    var pincodeForm = document.getElementById('lag-now-pincode-form');
    if (pincodeForm) {
      pincodeForm.addEventListener('submit', function (e) {
        e.preventDefault();
        handleManualSubmit();
      });
    }

    // Allow only digits in pincode input
    var pincodeInput = document.getElementById('lag-now-pincode-input');
    if (pincodeInput) {
      pincodeInput.addEventListener('input', function () {
        this.value = this.value.replace(/\D/g, '').substring(0, 6);
        // Hide error on input
        var errorEl = document.getElementById('lag-now-pincode-error');
        if (errorEl) errorEl.setAttribute('hidden', '');
        // Hide confirm messages too
        var el1 = document.getElementById('lag-now-confirm-eligible');
        var el2 = document.getElementById('lag-now-confirm-ineligible');
        if (el1) el1.setAttribute('hidden', '');
        if (el2) el2.setAttribute('hidden', '');
      });
    }
  }

  /* ─────────────────────────────────────────────
   * 14. INIT
   * ───────────────────────────────────────────── */
  function init() {
    portalToBody();
    restoreFromStorage();
    bindEvents();

    // If we arrived here from an out-of-range click on the floating
    // button (it appends ?lag_oos=1), show the "Service Not Available"
    // message now, on THIS page — not on the page they came from.
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get('lag_oos') === '1') {
        // Small delay so the modal opens after first paint settles.
        setTimeout(function () { showOutOfRangeModal(); }, 250);
        // Remove the flag from the URL so a refresh doesn't re-trigger
        // the modal. replaceState keeps the history stack intact (no
        // effect on the Back button).
        try {
          params.delete('lag_oos');
          var qs = params.toString();
          var newUrl = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
          window.history.replaceState(null, '', newUrl);
        } catch (e) {}
      }
    } catch (e) {}

    // Pincode decision: if we already have a valid pincode this session,
    // use it. Otherwise, do nothing — no automatic popup. The customer's
    // pincode stays unknown until they manually check via the floating
    // "Lagorii Now" button or "Deliver to" on the timer bar.
    var storedPin = lsGet(LS.PINCODE);

    if (storedPin && isValidPincode(storedPin)) {
      applyPincode(storedPin, false);
    }
  }

  // Kick off after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose public API for Liquid/other scripts
  window.LagNow = {
    applyPincode: applyPincode,
    checkEligibility: checkEligibility,
    openModal: showManualEntry,
    closeModal: closeModal
  };

})();